import React, { useCallback } from "react";
import Form from "react-bootstrap/Form";
import { Formik } from "formik";
import * as yup from "yup";
import "./template-task-creation.scss";
import TemplateTaskCreationPanelFormTopNew from "./template-task-creation-form-top-new";
import TemplateTaskCreationPanelFormMiddleNew from "./template-task-creation-form-middle-new";
import TemplateTaskCreationPanelFormBottomNew from "./template-task-creation-form-bottom-new";
import {
  CreateTemplateTaskAPI,
  EditTemplateTaskAPI,
} from "../../../../../services/api/project-template-api";
import { PrepareFileData, UploadFiles } from "../template-task-utility";
import PropTypes from "prop-types";

const TemplateTaskCreationPanelFormNew = ({
  isCreate,
  isSubtask,
  taskTypes,
  setAlertConfig,
  isView,
  isEdit,
  task,
  setPanelVisibility,
  templateId,
  templateName,
}) => {
  const SaveTaskTemplate = useCallback(async (values, actions) => {
    try {
      let files = await UploadFiles(values?.AddedFormFiles);

      let attachments = PrepareFileData(files.data, values.Attachments);
      actions.setFieldValue("Attachments", [...attachments]);
      values.Attachments = attachments;
      values.ProjectTypeId = templateId;

      let result = isEdit
        ? await EditTemplateTaskAPI(values)
        : await CreateTemplateTaskAPI(values);

      if (result?.response?.status === 200 || result?.status === 200) {
        actions.resetForm({ values: { ...task } });
        setPanelVisibility((prev) => ({
          ...prev,
          showConfirmPanel: !isCreate,
          showCreatePanel: isCreate,
        }));
      } else {
        throw new Error(result.response.data);
      }
    } catch (error) {
      setAlertConfig((prevState) => ({
        ...prevState,
        showAlert: true,
        alertMessage: error.toString(),
      }));
    }
    actions.setSubmitting(false);
  }, []);

  const OnKeyDown = (keyEvent) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  };

  return (
    <div
      className="template-task-create-standard-panel"
      onClick={() => {
        setAlertConfig((prevState) => ({
          ...prevState,
          showAlert: false,
        }));
      }}
    >
      <Formik
        key={task.Id}
        validationSchema={yup.object({
          Name: yup.string().required("Task Name Required"),
          // subTaskName: isSubtask
          //   ? yup.string().required("Subtask Name Required")
          //   : yup.string(),
          WorkItemTypeId: yup
            .number()
            .integer()
            .moreThan(0, "Select A Valid Task Management Type")
            .required("Task Type Required"),
          Priority: yup
            .number()
            .integer()
            .moreThan(0, "Select A Valid Priority")
            .lessThan(5, "Select A Valid Priority")
            .required("Task Priority Required"),
          AllApprovers: yup.boolean(),
          RecurringImmediate: yup.boolean(),
        })}
        initialValues={{
          ...task,
        }}
        onSubmit={(values, actions) => {
          SaveTaskTemplate(values, actions);
        }}
        validator={() => ({})}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          errors,
          setFieldValue,
          setFieldTouched,
          isSubmitting,
          submitForm,
        }) => (
          <Form
            onSubmit={handleSubmit}
            className="template-task-create-container"
            onKeyDown={OnKeyDown}
          >
            <TemplateTaskCreationPanelFormTopNew
              isSubtask={isSubtask}
              values={values}
              handleChange={handleChange}
              handleBlur={handleBlur}
              touched={touched}
              errors={errors}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
              taskTypes={taskTypes}
              templateName={templateName}
            ></TemplateTaskCreationPanelFormTopNew>

            <TemplateTaskCreationPanelFormMiddleNew
              isSubtask={isSubtask}
              values={values}
              handleChange={handleChange}
              handleBlur={handleBlur}
              touched={touched}
              errors={errors}
              setFieldValue={setFieldValue}
            ></TemplateTaskCreationPanelFormMiddleNew>

            <TemplateTaskCreationPanelFormBottomNew
              isSubmitting={isSubmitting}
              submitForm={submitForm}
              isView={isView}
              isEdit={isEdit}
              setPanelVisibility={setPanelVisibility}
            ></TemplateTaskCreationPanelFormBottomNew>
          </Form>
        )}
      </Formik>
    </div>
  );
};

TemplateTaskCreationPanelFormNew.propTypes = {
  isCreate: PropTypes.bool,
  isSubtask: PropTypes.bool,
  taskTypes: PropTypes.array,
  setAlertConfig: PropTypes.func,
  isView: PropTypes.bool,
  isEdit: PropTypes.bool,
  task: PropTypes.object,
  setPanelVisibility: PropTypes.func,
  templateId: PropTypes.number,
  templateName: PropTypes.string,
};
export default TemplateTaskCreationPanelFormNew;
